var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "span",
    {
      staticClass: "tooltip tooltip-icon",
      class: _vm.cssClass,
      attrs: {
        "data-tooltip": "",
        title: _vm.title,
        tabindex: "0"
      }
    },
    [
      _vm.isHtml
        ? _c("span", {
            staticClass: "tooltip-content",
            domProps: {
              innerHTML: _vm._s(_vm.text)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("studip-icon", {
        attrs: {
          shape: "info-circle",
          role: "inactive",
          size: _vm.size
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }